import { render } from "./ModalBlock.vue?vue&type=template&id=5db9d774&scoped=true&ts=true"
import script from "./ModalBlock.vue?vue&type=script&lang=ts"
export * from "./ModalBlock.vue?vue&type=script&lang=ts"

import "./ModalBlock.vue?vue&type=style&index=0&id=5db9d774&scoped=true&lang=css"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db9d774"]])

export default __exports__